import React from 'react';
import {
  Box, Typography, Button, Container, Card, CardContent
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { useNavigation } from '../lib/NavigationContext';

export default function History() {
  const { navigateTo } = useNavigation();

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 4 }}>
        <Box>
          <Typography variant="h5" fontWeight={700}>Storico Preventivi</Typography>
          <Typography variant="body2" color="text.secondary">Visualizza e gestisci i preventivi salvati</Typography>
        </Box>
        <Button onClick={() => navigateTo('Quote')} variant="outlined" startIcon={<ArrowBackIcon />} size="small">
          Torna ai Preventivi
        </Button>
      </Box>

      <Card elevation={3}>
        <CardContent sx={{ p: 8, textAlign: 'center' }}>
          <Box sx={{ width: 80, height: 80, borderRadius: '50%', bgcolor: 'action.hover', display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 3 }}>
            <AccessTimeIcon sx={{ fontSize: 40, color: 'text.disabled' }} />
          </Box>
          <Typography variant="h6" color="text.secondary" gutterBottom>Nessuno storico disponibile</Typography>
          <Typography variant="body2" color="text.disabled" sx={{ maxWidth: 400, mx: 'auto' }}>
            I preventivi salvati appariranno qui. Crea il tuo primo preventivo per iniziare.
          </Typography>
          <Button onClick={() => navigateTo('Quote')} variant="contained" startIcon={<NoteAddIcon />} sx={{ mt: 3 }}>
            Nuovo Preventivo
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
}